import React from 'react';
import { useStyles } from './FullPageMessage.styles';
import { Typography, Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';
export const FullPageMessage = (props) => {
    const classes = useStyles();
    const buttonLink = React.forwardRef((props, ref) => (React.createElement(Link, Object.assign({}, props, { ref: ref }))));
    return (React.createElement(Box, { component: "section", sx: classes.root },
        React.createElement(Typography, { sx: classes.title, variant: "h1" }, props.title),
        React.createElement(Typography, { variant: "h4", sx: classes.description }, props.description),
        React.createElement(Button, { to: "/", component: buttonLink, variant: "contained", color: "primary", size: "large" }, "G\u00E5 till startsidan")));
};
export default FullPageMessage;
